import type { Filter } from 'src/redux/productsQuery/types/Filter';
import type { BrowseDataAPIFilter } from 'src/services/browse-data-api/types/BrowseDataAPIFilter';

export const adaptBrowseFilters = (browseFilters: BrowseDataAPIFilter[]): Filter[] => {
  return browseFilters.map((filter) => {
    const { expandedByDefault, ...restOfFilter } = filter;

    return {
      ...restOfFilter,
      options: filter.options.map((option) => {
        const { tooltip, ...restOfOption } = option;

        return restOfOption;
      }),
    };
  });
};
